<template>
  <div class="row">
    <div class="col-md-12">
      <b-row align-v="center" align-h="center" class="mt-2 mb-4">
        <b-col>
          <b-row>
            <template v-if="showEventList">
              <b-col>
                <b-button  size="lg" title="EVENTs" class="mr-1" style="margin: auto; background-color: #AAA">
                  EVENTs
                </b-button>
              </b-col>
            </template>
            <template v-else>
              <b-col>
                <b-button size="lg" title="EVENTs" @click.prevent="showList('EVENTs')" class="mr-1" style="margin: auto;">
                  EVENTs
                </b-button>
              </b-col>
            </template>
          </b-row>
        </b-col>
        <b-col>
          <b-row  style="float: center;">
            <template v-if="showCardList">
              <b-col>
                <b-button  size="lg" title="CARDs" class="mr-1" style="float: center; background-color: #AAA">
                  CARDs
                </b-button>
              </b-col>
            </template>
            <template v-else>
              <b-col>
                <b-button size="lg" title="CARDs" @click.prevent="showList('CARDs')" class="mr-1" style="float: center;">
                  CARDs
                </b-button>
              </b-col>
            </template>
          </b-row>
        </b-col>
        <b-col>
          <b-row  style="float: center;">
            <template v-if="showUserList">
              <b-col>
                <b-button  size="lg" title="USERs" class="mr-1" style="background-color: #AAA">
                  USERs
                </b-button>
                <router-link :to="{ name: 'add_user'}">
                  <b-button size="lg" title="crea USER" class="ml-1" style="">
                    +
                  </b-button>
                </router-link>
              </b-col>
            </template>
            <template v-else>
              <b-col>
                <b-button size="lg" title="USERs" @click.prevent="showList('USERs')" class="mr-1" style="float: center;">
                  USERs
                </b-button>
              </b-col>
            </template>
          </b-row>
        </b-col>
      </b-row>
<!-- 
      <template v-if="showUserList">
        <UserList />
      </template>
      <template v-else-if="showCardList">
        <CardList />
      </template>
      <template v-else-if="showEventList">
        <EventList />
      </template> -->
    </div>
  </div>
</template>

<script>
 /* import UserList from '../components/users/UserList.vue'
  import CardList from '../components/cards/CardList.vue'
  import EventList from '../components/events/EventList.vue'
  import { mapGetters } from 'vuex'
*/

  export default {
    data() {
      return {
        showUserList: false,
        showCardList: false,
        showEventList: false,
      }
    },
    /*computed: {
      ...mapGetters({
        // map `this.user` to `this.$store.getters.user`
        user: "user",
        user_claims: "user_claims",
      })
    },*/
    created() {
      if (this.$route.name === 'welcome') this.$router.push({ name: 'list_users' });
      else if (this.$route.name === 'list_users') this.showUserList = true;
      else if (this.$route.name === 'list_cards') this.showCardList = true;
      else if (this.$route.name === 'list_events') this.showEventList = true;
    },
    methods: {
      showList(listName) {
        this.showUserList = false
        this.showCardList = false
        this.showEventList = false

        switch(listName) {
          case ("USERs"):
            this.showUserList = true
            //this.$route.name === 'list_users'
            this.$router.push({name:'list_users'})
            break
          case ("CARDs"):
            this.showCardList = true
            //this.$route.name === 'list_cards'
            this.$router.push({name:'list_cards'})
            break
          case ("EVENTs"):
            this.showEventList = true
            //this.$route.name === 'list_events'
            this.$router.push({name:'list_events'})
            break
          default:
            this.showUserList = true
            this.$router.push({name:'list_users'})
            break
        }
      },
    },
    /*components: {
      UserList,
      CardList,
      EventList
    }*/
  };
</script>

<style>
  .welcome {
    text-align: center;
    padding: 20px 0;
  }
  .linkable {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
</style>